import { BarChart as BaseBarChart } from "@mui/x-charts/BarChart";
import { LineChart as BaseLineChart } from "@mui/x-charts/LineChart";
import { CurveType } from "@mui/x-charts";
import { IconName } from "components/ui/Icon";
import { BarChart, LineChart } from "../../../components/Chart";

export const CHART_TYPE_OPTIONS: {
  name: "line" | "bar";
  icon: IconName;
  component: typeof BaseBarChart | typeof BaseLineChart;
}[] = [
  {
    name: "bar",
    icon: "chartSimple",
    component: BarChart,
  },
  {
    name: "line",
    icon: "chartLine",
    component: LineChart,
  },
];

export const CHART_PERIOD_OPTIONS: {
  name: "daily" | "monthly";
  label: string;
}[] = [
  { name: "daily", label: "30D" },
  { name: "monthly", label: "Monthly" },
];

export const CURVE: CurveType = "natural";
